<template>
  <div class="page flex-col">
    <LoginButton />
    <div class="scaler" style="margin-top: -80px; z-index: 1">
      <div class="text-wrapper_3 flex-row">
        <span class="text_1">您好，</span>
        <span class="text_2">候选人</span>
      </div>
      <span class="text_3">您正在与AI面试官Cathy沟通中</span>
      <div class="box_2 flex-col">
        <div class="group_1 flex-row justify-between">
          <img class="label_1" referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG8c4490ef17ed7abdd3d6641305cdc290.png" />
          <span class="text_5" style="line-height: 42px">
            {{ String(leftMinutes).padStart(2, '0') + ':' + String(leftSeconds).padStart(2, '0') }}
          </span>
        </div>
        <div class="image-wrapper_1 flex-col"
          style="border: dashed 5px rgba(126, 180, 235, 1); border-radius: 20px; overflow: hidden"
          id="interview_ing_video">
<!--           <img class="image_1" referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG86354fd4121a60c50dd81ab7a0e89a66.png" /> -->
          <img v-if="cameraAccess == 'denied' || closeVideoTransfer" class="image_1_" referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNG7299e06472f6ba6e89deac96771f2e41.png" />
          <span v-if="cameraAccess == 'denied' || closeVideoTransfer" class="text_2_">摄像头画面未授权</span>
          <VERTCVideo :whiteIntensity="setting.whiteIntensity" :smoothIntensity="setting.smoothIntensity"
            :sharpenIntensity="setting.sharpenIntensity" :filterIntensity="setting.filterIntensity"
            :filterType="setting.filterType" refName="interview_ing_video" :closeVideoTransfer="closeVideoTransfer"
            :closeAudioTransfer="closeAudioTransfer" ref="videoRef" @done="done()" @idle="playAnim('idle')"
            @talk="playAnim('talk')">
          </VERTCVideo>
        </div>
        <div class="group_2 flex-row justify-between">
          <div class="image-wrapper_2 flex-col" style="overflow: hidden; cursor: pointer" @click="
            pauseAudio()
            ">
            <img class="label_2" referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNGb7e2fa27b8735b359e21484f3a044e01.png" />
            <div v-if="closeAudioTransfer" class="not-allowed"></div>
          </div>
          <div class="image-wrapper_3 flex-col" style="overflow: hidden; cursor: pointer" @click="pauseRecording()">
            <img class="label_3" referrerpolicy="no-referrer"
              src="./assets/img/FigmaDDSSlicePNG7c0648bd414304dfd5639d1220bf3c1d.png" />
            <div v-if="closeVideoTransfer" class="not-allowed"></div>
          </div>

        </div>
      </div>
      <div class="text-wrapper_2 flex-col">
        <span @click="overInterview()" class="text_4"
          style="line-height: 45px; cursor: pointer">结束面试</span>
      </div>
    </div>
    <!-- 添加AI音频流处理组件 -->
    <!--     <div class="audio-stream-container" v-if="showAudioProcessor">
      <AudioProcessor :interviewId="$store.state.interviewState.interviewId" />
      <el-button type="info" size="small" @click="toggleAudioProcessor" style="margin-top: 10px"> {{ showAudioProcessor ? '隐藏' : '显示' }}音频处理 </el-button>
    </div> -->
    <!-- 这里canvas的background可以用来为renderer的背景添加叠加色 -->
    <!-- <div style="position:absolute;width:100vw;height:100vh;background:black;" ref="canvas"></div> -->
    <!--     <div style="position: absolute; width: 100vw; height: 100vh; pointer-events: none">
      <img
        :src="anim.curAnim == 'idle' ? 'https://static.www.yuugeai.com/image/quiet_Scene1.c04f307c.gif' : 'https://static.www.yuugeai.com/image/speaking_Scene2.b3fa35cb.gif'"
        style="width: 1000px; height: 1414px; z-index: 1; position: absolute; margin-left: -5vw; margin-top: -10vh" />
      <img :src="setting.backgroundPath" style="width: 100%; height: 100%" />
    </div> -->
    <div style="position: absolute; width: 100vw; height: 100vh; pointer-events: none">
      <img v-show="anim.curAnim === 'idle'" src="https://static.www.yuugeai.com/image/quiet_Scene1.c04f307c.gif"
        style="width: 1000px; height: 1414px; z-index: 1; position: absolute; margin-left: 200px; margin-top: -100px" />
      <img v-show="anim.curAnim !== 'idle'" src="https://static.www.yuugeai.com/image/speaking_Scene2.b3fa35cb.gif"
        style="width: 1000px; height: 1414px; z-index: 1; position: absolute; margin-left: 199px; margin-top: -101px" />
      <img :src="setting.backgroundPath" style="width: 100%; height: 100%" />
    </div>
    <!-- 自定义弹窗 -->
    <div v-show="waitForOverInterview" class="custom-popup">
      <div class="popup-content">
        <img src="./assets/img/interviewFinish.gif" alt="Loading" class="popup-image" />
        <div class="popup-text">
          面试官正在解析您的答案
          <br>请稍等片刻
        </div>
      </div>
    </div>

    <!-- 噪音检测弹窗 -->
    <div v-if="showNoiseDetection" class="custom-popup">
      <div class="popup-content noise-detection-popup">
        <div class="noise-detection-header">
          <div class="noise-title-spacer"></div>
          <h3 class="noise-title">正在进行噪音检测</h3>
          <button class="close-btn" @click="closeNoiseDetection">×</button>
        </div>
        
        <div class="noise-content">
          <div class="noise-image">
            <img src="./assets/img/check.png" alt="噪音检测" class="check-image" />
          </div>
          
          <div class="noise-info">
            <p class="noise-message">当前环境声源复杂,可能会对您面试的评分产生影响哦~换个安静些的环境吧</p>
            
            <div class="noise-level-indicator">
              <div class="progress-bar-container">
                <div class="progress-bar">
                  <div class="progress-fill" :style="{ width: (noiseLevel / 80 * 100) + '%' }"></div>
                  <div class="progress-marker" style="left: 81.25%"></div>
                  <div class="progress-current" :style="{ left: (noiseLevel / 80 * 100) + '%' }"></div>
                </div>
                <div class="progress-labels">
                  <span class="label-0">0dB</span>
                  <span class="label-50" style="position: absolute; left: 81.25%; transform: translateX(-50%);">65dB</span>
                  <span class="label-80">80dB</span>
                </div>
              </div>
              <div class="noise-labels">
                <span class="current-noise" :class="{ 'noise-high': noiseLevel > 65 }">
                  当前环境音: {{ noiseLevel }}dB
                </span>
                <span class="recommended-noise">推荐环境音: &lt;65dB</span>
              </div>
            </div>
            
            <div class="noise-actions">
              <button class="btn btn-outline" @click="startLater">稍后开始</button>
              <button class="btn btn-gradient" @click="startInterview" :disabled="noiseLevel > 65">
                开始面试
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 自定义 开始面试 确认弹窗 -->
    

    <!-- 自定义 不足5分钟 结束面试 确认弹窗 -->
    <div v-if="showShortEndConfirm" class="custom-popup">
      <div class="popup-content" style="max-width: 460px;">
        <img :src="tipImgUrl" alt="tip" class="popup-image" style="width: 140px;" />
        <div class="ui-title">确定要结束面试吗？</div>
        <div class="ui-desc">
          您的面试时间过短（<span class="ui-strong">小于一分钟</span>），我们无法对您进行全面的评估。因此将<span class="ui-strong">不会产生面试成绩</span>哦~
        </div>
        <div class="ui-actions">
          <button class="btn btn-outline" @click="handleShortEndConfirm">确定结束</button>
          <button class="btn btn-gradient" @click="handleShortEndCancel">继续面试</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import * as THREE from 'three'
// import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
// import CameraJson from './assets/model/camera.json'
// import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import VERTCVideo from '@/components/VERTCVideo/index.vue'
// import SideBar from '@/components/SideBar/index.vue'
// import AudioProcessor from '@/components/AudioProcessor/index.vue'
import axios from 'axios'
import RtcClient from '@/rtc/RtcClient.js'
import cameraManager from '@/utils/CameraManager.js'
import VERTC from '@volcengine/rtc'
import { getRtcToken } from '@/api/rtc.js'
import { tlv2String } from '@/utils/rtcUtil.js'
import { lxUploadFile, saveInterviewScreenshot } from '@/api/upload.js'
import QuietScene from './assets/img/quiet_Scene1.gif'
import SpeakingScene from './assets/img/speaking_Scene2.gif'
import { getRecommendVideo } from '@/api/recommend'
import { FIXED_BORDER } from '@/constants/prompt'
export default {
  components: {
    VERTCVideo,
    // SideBar,
    // AudioProcessor,
  },
  created() {

    try {
      const raw = localStorage.getItem('jobInformation');
      if (raw) {
        const { position } = JSON.parse(raw) || {};

        this.position = position;

      }
    } catch (e) {
      // 数据损坏或格式错误时兜底
      console.warn('jobInformation 不存在', e);
    }



    /*     this.leftMinutes = this.$store.state.interviewState.interviewDuration
    
        this.leftSeconds = 0
        this.timer = setInterval(() => {
          // 计算总剩余秒数
          const totalSeconds = this.leftMinutes * 60 + this.leftSeconds
    
          // 当剩余时间等于30秒时触发提示
          if (totalSeconds === 30) {
            // 发送中优先级文本（等待当前语音播放完毕）
            this.handleThirtySecondsLeft()
    
          }
          if (this.leftSeconds > 0) this.leftSeconds--
          else if (this.leftMinutes > 0) {
            this.leftMinutes--
            this.leftSeconds = 59
          } else {
            clearInterval(this.timer)
            // 当时间结束时显示弹窗提示，然后结束面试
            this.$message.info({
              message: '因为时间的原因，我们的面试到此结束，感谢您参加此次面试',
              duration: 5000,
              onClose: () => {
                this.overInterview()
              }
            })
          }
        }, 1000) */
    const interviewState = this.$store.state.interviewState
    if (!interviewState.interviewStarted) this.$router.push('/')
    const setting = {
      whiteIntensity: 0,
      smoothIntensity: 0,
      sharpenIntensity: 0,
      filterType: '不使用',
      filterIntensity: 0,
      backgroundPath: require('./assets/img/FigmaDDSSlicePNGbc009092560cf51ca0559a58d4f877d3_clip.png'),
    }
    for (const key in interviewState.usingBeautifys) {
      const beautify = interviewState.usingBeautifys[key]
      switch (beautify.name) {
        case '美白':
          setting.whiteIntensity = beautify.slideValue * 0.01
          break
        case '磨皮':
          setting.smoothIntensity = beautify.slideValue * 0.01
          break
        case '锐化':
          setting.sharpenIntensity = beautify.slideValue * 0.01
          break
      }
    }
    if (interviewState.usingFilter && interviewState.usingFilter.name != '不使用') {
      setting.filterType = interviewState.usingFilter.name
      setting.filterIntensity = interviewState.usingFilter.slideValue * 0.01
    }
    if (interviewState.usingBackground && interviewState.usingBackground.name != '不使用') {
      setting.backgroundPath = interviewState.usingBackground.img
    }
    this.setting = setting
  },

  async mounted() {

    this.showNoiseDetection = true
    this.startNoiseDetection()
    this.$message.success('请打开面试录制，我们会根据录制视频为您的面试表现评分。')
    // this.initScene()
    // window.addEventListener('resize', () => {
    //   this.renderer.setSize(window.innerWidth, window.innerHeight)
    // })
    // const recordFunc = this.recordCurrentCamera
    // document.addEventListener('keydown', function (event) {
    //   if (event.key == 'R' || event.key == 'r') {
    //     recordFunc()
    //   }
    // })
    const permissionStatus = await navigator.permissions.query({ name: 'camera' })
    this.cameraAccess = permissionStatus.state
    permissionStatus.onchange = () => {
      this.cameraAccess = permissionStatus.state
    }


    await this.initializeRtc()
  },
  data() {
    return {
      isFinalQuestionAsked: false,
      microphone: null,
      timer: null,
      speaking: false,
      waitForOverInterview: false,
      closeVideoTransfer: true,
      closeAudioTransfer: true,
      cameraAccess: 'denied',
      leftMinutes: 0,
      leftSeconds: 0,
      setting: null,
      scene: null,
      renderer: null,
      loader: null,
      camera: null,
      controls: null,
      mixers: [],
      blobUrl: '',
      showAudioProcessor: false,
      anim: {
        curAnim: 'idle',
        idleUrl: require('./assets/img/quiet_Scene2.gif'),
        talkUrl: require('./assets/img/speaking_Scene2.gif'),
      },
      isRtcInitialized: false,
      isRtcConnected: false,
      isAiSpeaking: false,
      rtcStatusMessage: '等待初始化...',
      userId: '',
      roomId: '',
      appId: '67adf9d0d35c9e01792239ae',
      token: '',
      botName: 'RobotMan_',
      welcomeMessage: '你好，我是你的AI面试官 Cathy，请问准备好开始面试了吗？',
      msgHis: [],
      msgHisIndex: 0,
      QuietScene,
      SpeakingScene,
      position: '',
      animDebounceTimer: null, // 动画防抖定时器
      lastAnimSwitchTime: 0, // 最后一次动画切换时间
      startTimestamp: null, // 面试开始时间
      isShortInterview: false, // 是否为不足5分钟的面试
      showShortEndConfirm: false,
      prevAudioClosed: true,
      prevVideoClosed: true,
      tipImgUrl: require('./assets/img/tips.png'),
      showNoiseDetection: false,
      noiseLevel: 0,
      noiseDetectionInterval: null,
      audioContext: null,
      analyser: null,
      microphone: null,
      dataArray: null,
      noiseLevelHistory: [],
      maxHistorySize: 10,
      currentStream: null,
      screenshotTimer: null,
      screenshotCount: 0,
      maxScreenshots: 4,
      screenshotUrls: [],
      interviewStartTime: null,
    }
  },
  methods: {
    startInterviewTimer() {
      this.leftMinutes = this.$store.state.interviewState.interviewDuration;
      this.leftSeconds = 0;
      this.timer = setInterval(() => {
        const totalSeconds = this.leftMinutes * 60 + this.leftSeconds;
        if (totalSeconds === 30 && !this.isFinalQuestionAsked) {
          this.handleThirtySecondsLeft();
        }
        if (this.leftSeconds > 0) {
          this.leftSeconds--;
        } else if (this.leftMinutes > 0) {
          this.leftMinutes--;
          this.leftSeconds = 59;
        } else {
          clearInterval(this.timer);
          this.$message.info({
            message: '因为时间的原因，我们的面试到此结束，感谢您参加此次面试',
            duration: 5000,
            onClose: () => this.overInterview()
          });
        }
      }, 1000);
    },
    async pauseAudio() {
      this.closeAudioTransfer = !this.closeAudioTransfer
      if (this.closeAudioTransfer) {
        console.log('暂停音频传输');
        await RtcClient.stopAudioCapture()
      } else {
        console.log('恢复音频传输');
        await RtcClient.startAudioCapture(this.microphone)
      }

    },
    async startNoiseDetection() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
        this.currentStream = stream
        
        this.audioContext = new (window.AudioContext || window.webkitAudioContext)()
        this.analyser = this.audioContext.createAnalyser()
        this.microphone = this.audioContext.createMediaStreamSource(stream)
        
        this.analyser.fftSize = 512
        this.analyser.smoothingTimeConstant = 0.85
        this.microphone.connect(this.analyser)
        
        const bufferLength = this.analyser.frequencyBinCount
        this.dataArray = new Uint8Array(bufferLength)
        
        this.noiseLevelHistory = []
        
        this.startRealTimeAnalysis()
        
        this.$message.success('开始噪音检测，请保持安静')
      } catch (error) {
        console.error('无法访问麦克风:', error)
        this.$message.error('无法访问麦克风，请检查权限设置')
        this.startSimulatedNoiseDetection()
      }
    },
    startRealTimeAnalysis() {
      this.noiseDetectionInterval = setInterval(() => {
        if (this.analyser && this.dataArray) {
          this.analyser.getByteFrequencyData(this.dataArray)
          
          let sumSquares = 0
          let validSamples = 0
          for (let i = 0; i < this.dataArray.length; i++) {
            const value = this.dataArray[i]
            if (value > 0) {
              sumSquares += value * value
              validSamples++
            }
          }
          
          if (validSamples === 0) {
            return
          }
          
          const rms = Math.sqrt(sumSquares / validSamples)
          
          const normalized = rms / 255
          let dbLevel = 0
          
          if (normalized > 0.001) {
            dbLevel = 20 * Math.log10(normalized * 50) + 30
            dbLevel = Math.max(30, Math.min(80, dbLevel))
          } else {
            dbLevel = 30
          }
          
          this.noiseLevelHistory.push(dbLevel)
          
          if (this.noiseLevelHistory.length > this.maxHistorySize) {
            this.noiseLevelHistory.shift()
          }
          
          const historyLength = this.noiseLevelHistory.length
          if (historyLength > 0) {
            const sum = this.noiseLevelHistory.reduce((a, b) => a + b, 0)
            const smoothedLevel = sum / historyLength
            
            const alpha = historyLength < 5 ? 0.5 : 0.3
            const previousLevel = this.noiseLevel || smoothedLevel
            const finalLevel = alpha * smoothedLevel + (1 - alpha) * previousLevel
            
            this.noiseLevel = Math.round(finalLevel)
          }
        }
      }, 300)
    },

    startSimulatedNoiseDetection() {
      this.noiseLevel = 40
      
      this.noiseDetectionInterval = setInterval(() => {
        const baseLevel = 40
        const variation = (Math.random() - 0.5) * 8
        this.noiseLevel = Math.max(30, Math.min(60, baseLevel + variation))
      }, 2000)
    },

    stopNoiseDetection() {
      if (this.noiseDetectionInterval) {
        clearInterval(this.noiseDetectionInterval)
        this.noiseDetectionInterval = null
      }
      
      if (this.currentStream) {
        this.currentStream.getTracks().forEach(track => {
          track.stop()
        })
        this.currentStream = null
      }
      
      if (this.microphone && typeof this.microphone.disconnect === 'function') {
        this.microphone.disconnect()
        this.microphone = null
      } else if (this.microphone) {
        // 如果 microphone 不是 MediaStreamAudioSourceNode，直接设置为 null
        this.microphone = null
      }
      
      if (this.analyser) {
        this.analyser.disconnect()
        this.analyser = null
      }
      
      if (this.audioContext && this.audioContext.state !== 'closed') {
        this.audioContext.close().catch(err => {
          console.warn('关闭音频上下文失败:', err)
        })
        this.audioContext = null
      }
      
      this.dataArray = null
      this.noiseLevelHistory = []
    },

    closeNoiseDetection() {
      this.showNoiseDetection = false
      this.stopNoiseDetection()
    },

    startLater() {
      this.closeNoiseDetection()
      this.$router.push('/')
    },

    async startInterview() {
      if (this.noiseLevel > 65) {
        this.$message.warning('环境噪音过高，请选择安静的环境后再开始面试')
        return
      }
      
      this.closeNoiseDetection()
      this.closeAudioTransfer = false
      this.closeVideoTransfer = false
      await this.$refs.videoRef.startRecording()
      await this.connectAndStartAi()
      this.startTimestamp = Date.now()
      this.interviewStartTime = Date.now()
      this.startInterviewTimer();
      this.startScreenshotTimer();
      // 开始面试后调用推荐视频获取
      this.fetchRecommendVideos();
    },

    showStartInterviewConfirm() {
      this.$confirm('是否开始面试？（请注意保持环境安静，防止干扰面试过程）', '提示', {
        confirmButtonText: '开始面试',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
        closeOnPressEscape: false,
      })
        .then(async () => {
          this.closeAudioTransfer = false
          this.closeVideoTransfer = false
          await this.$refs.videoRef.startRecording()
          await this.connectAndStartAi()
          this.startTimestamp = Date.now()
          this.startInterviewTimer();
        })
        .catch(() => {
          // 取消时保持关闭状态
        })
    },
    initScene() {
      const self = this
      this.scene = new THREE.Scene()
      const light = new THREE.AmbientLight(0xffffff, 1)
      this.scene.add(light)
      const dirLight = new THREE.DirectionalLight('rgb(253,253,253)', 2.5)
      dirLight.position.set(0, 0, 1) // 根据需要自行调整位置
      this.scene.add(dirLight)
      const backgroundPath = this.setting.backgroundPath
      const textureLoader = new THREE.TextureLoader()
      textureLoader.load(
        backgroundPath,
        (texture) => {
          this.scene.background = texture // 设置场景背景
        },
        undefined,
        (error) => {
          console.error('Background texture loading error:', error)
        }
      )
      this.loader = new GLTFLoader()
      // const amyPath = require('./assets/model/amy.glb').default // 这里注意要有default
      const request = indexedDB.open('ModelDatabase', 1)
      request.onupgradeneeded = function (event) {
        //仅在数据库版本升级时调用，比如0->1，未创建时为0
        const db = event.target.result
        db.createObjectStore('models', { keyPath: 'id' })
      }
      request.onsuccess = function (event) {
        const db = event.target.result
        const transaction = db.transaction(['models'], 'readonly')
        const objectStore = transaction.objectStore('models')
        // const getRequest = objectStore.get('amy.glb')
        const getRequest = objectStore.get('CathyTalking.glb')
        getRequest.onsuccess = function (event) {
          const model = event.target.result
          if (model) {
            self.$message('模型内容:' + model.id)
            self.blobUrl = URL.createObjectURL(model.content)
            self.initModel()
          } else {
            self.$message('浏览器没有缓存模型文件，正在为您下载...')
            //const amyPath = window.origin + '/model/amy.glb'
            const amyPath = window.origin + '/model/CathyTalking.glb'
            axios
              .get(amyPath, { responseType: 'blob' })
              .then((response) => {
                const blob = response.data
                const transaction = db.transaction(['models'], 'readwrite')
                const objectStore = transaction.objectStore('models')
                //const modelData = { id: 'amy.glb', content: blob }
                const modelData = { id: 'CathyTalking.glb', content: blob }
                const addRequest = objectStore.add(modelData)
                addRequest.onsuccess = function () {
                  console.log('模型文件已成功存储到 IndexedDB')
                }
                self.blobUrl = URL.createObjectURL(blob)
                self.initModel()
              })
              .catch((error) => {
                console.error('获取文件失败：' + error)
              })
          }
        }
      }
    },
    initModel() {
      // this.loadModel(amyPath)
      this.loadModel(this.blobUrl)
      // this.camera = new THREE.PerspectiveCamera(75, window.innerWidth/window.innerHeight, 0.1, 1000)
      const aspectRatio = window.innerWidth / window.innerHeight // 计算纵横比
      const frustumSize = 0.75 // 可视空间的大小
      this.camera = new THREE.OrthographicCamera(
        (frustumSize * aspectRatio) / -2, // left
        (frustumSize * aspectRatio) / 2, // right
        frustumSize / 2, // top
        frustumSize / -2, // bottom
        0.1, // near
        1000 // far
      )
      const position = {
        // x: CameraJson.amy[0].position.x,
        // y: CameraJson.amy[0].position.y,
        // z: CameraJson.amy[0].position.z
        x: CameraJson.cathy[0].position.x,
        y: CameraJson.cathy[0].position.y,
        z: CameraJson.cathy[0].position.z,
      }
      const rotation = {
        // x: CameraJson.amy[0].rotation._x,
        // y: CameraJson.amy[0].rotation._y,
        // z: CameraJson.amy[0].rotation._z
        x: CameraJson.cathy[0].rotation._x,
        y: CameraJson.cathy[0].rotation._y,
        z: CameraJson.cathy[0].rotation._z,
      }
      this.camera.position.set(position.x, position.y, position.z)
      this.camera.rotation.set(rotation.x, rotation.y, rotation.z)
      this.renderer = new THREE.WebGLRenderer()
      this.renderer.setSize(window.innerWidth, window.innerHeight)
      this.$refs.canvas.appendChild(this.renderer.domElement)
      //在这里启动OrbitControls来寻找最佳视角（通过recordCurrentCamera并写入camera.json)，用完请注释，因为OrbitControls同camera.rotation.set方法冲突
      //  this.controls = new OrbitControls(this.camera, this.renderer.domElement)
      this.animate()
    },
    loadModel(path) {
      this.loader.load(
        path,
        (model) => {
          this.scene.add(model.scene)
          const mixer = new THREE.AnimationMixer(model.scene)
          model.animations.forEach((clip) => {
            mixer.clipAction(clip).play()
          })
          this.mixers.push(mixer)
        },
        undefined,
        (error) => {
          console.error('An error occurred:', error)
        }
      )
    },
    animate() {
      requestAnimationFrame(this.animate)
      for (const mixer of this.mixers) {
        if (mixer) mixer.update(0.01)
      }
      //在这里启动OrbitControls来寻找最佳视角（通过recordCurrentCamera并写入camera.json)，用完请注释，因为OrbitControls同camera.rotation.set方法冲突
      //  this.controls.update()
      this.renderer.render(this.scene, this.camera)
    },
    recordCurrentCamera() {
      const result = {
        name: 'amy-talk',
        position: this.camera.position,
        rotation: this.camera.rotation,
      }
      console.log(JSON.stringify(result, null, 2))
    },
    pauseRecording() {
      this.closeVideoTransfer = !this.closeVideoTransfer
      if (this.closeVideoTransfer) {
        console.log('暂停视频传输');
        this.$refs.videoRef.pauseRecording()
      } else {
        console.log('恢复视频传输');
        this.$refs.videoRef.resumeRecording()
      }


    },

    async overInterview() {
      const now = Date.now()
      const elapsedSeconds = this.startTimestamp ? Math.floor((now - this.startTimestamp) / 1000) : null
      
      // 计算实际面试时长（分钟）并保存到store
      if (elapsedSeconds !== null) {
        const actualDurationMinutes = Math.round(elapsedSeconds / 60 * 10) / 10 // 保留一位小数
        this.$store.dispatch('interviewState/setActualInterviewDuration', actualDurationMinutes)
        console.log(`实际面试时长: ${actualDurationMinutes} 分钟`)
      }

      const proceedToEnd = async () => {
        this.closeVideoTransfer = true
        this.closeAudioTransfer = true
        this.waitForOverInterview = true
        clearInterval(this.timer)  // 清除计时器
        this.stopScreenshotTimer() // 停止定时拍照
        this.disconnectAndStopAi()
        console.log('面试对话', this.msgHis)

        this.msgHis?.forEach(dialogue => {
          this.$store.commit('interviewState/SET_DIALOGUES', dialogue)
        })

        this.$store.dispatch('interviewState/formatDialogues')

        this.$refs.videoRef.stopVideoRecorder(this.isShortInterview)

        // 保存面试截图
        await this.saveScreenshots()

        // 强制关闭所有媒体设备，彻底释放摄像头/麦克风
        await this.forceCloseAllMediaStreams()
      }

      if (elapsedSeconds !== null && elapsedSeconds < 60) {
        this.prevAudioClosed = this.closeAudioTransfer
        this.prevVideoClosed = this.closeVideoTransfer
        this.closeAudioTransfer = true
        this.closeVideoTransfer = true
        try { await RtcClient.stopAudioCapture() } catch (e) { }
        try { if (this.$refs.videoRef && this.$refs.videoRef.pauseRecording) this.$refs.videoRef.pauseRecording() } catch (e) { }
        this.showShortEndConfirm = true
      } else {
        proceedToEnd()
      }
    },
    handleShortEndCancel() {
      this.showShortEndConfirm = false
      this.closeAudioTransfer = this.prevAudioClosed
      this.closeVideoTransfer = this.prevVideoClosed
      if (!this.prevAudioClosed) {
        try { RtcClient.startAudioCapture(this.microphone) } catch (e) { }
      }
      if (!this.prevVideoClosed) {
        try { if (this.$refs.videoRef && this.$refs.videoRef.resumeRecording) this.$refs.videoRef.resumeRecording() } catch (e) { }
      }
    },
    async handleShortEndConfirm() {
      this.showShortEndConfirm = false
      this.isShortInterview = true
      this.closeVideoTransfer = true
      this.closeAudioTransfer = true
      this.waitForOverInterview = true
      clearInterval(this.timer)
      this.disconnectAndStopAi()
      this.msgHis?.forEach(dialogue => {
        this.$store.commit('interviewState/SET_DIALOGUES', dialogue)
      })
      this.$store.dispatch('interviewState/formatDialogues')
      this.$refs.videoRef.stopVideoRecorder(this.isShortInterview)
      // 保存面试截图
      await this.saveScreenshots()
      await this.forceCloseAllMediaStreams()
      
      // 等待足够的时间确保摄像头资源完全释放
      await new Promise(resolve => setTimeout(resolve, 1500))
      
      // 触发视频推荐获取
      this.fetchRecommendVideos()
      this.waitForOverInterview = false
      
      // 跳转到面试解析页面
      // this.$router.push({ path: '/store/Interview_Analysis', query: { feedback: '1', short: '1' } })
      //跳转到面试记录
      this.$router.push({path:'/store/dashboard/profile'})
    },
    // 彻底关闭摄像头/麦克风与所有媒体资源
    async forceCloseAllMediaStreams() {
      try {
        // 先让子组件释放自身资源（录屏流、FFmpeg、扩展等）
        if (this.$refs && this.$refs.videoRef && this.$refs.videoRef.releaseResources) {
          await this.$refs.videoRef.releaseResources()
        }
      } catch (e) {
        console.error('释放子组件媒体资源失败:', e)
      }

      try {
        await RtcClient.stopAudioCapture()
      } catch (e) {
        console.warn('停止音频采集时出现问题:', e)
      }

      try {
        await RtcClient.leaveRoom()
      } catch (e) {
        console.warn('离开房间时出现问题:', e)
      }

      try {
        if (RtcClient.destroyEngine) {
          await RtcClient.destroyEngine()
        }
      } catch (e) {
        console.warn('销毁 RTC 引擎时出现问题:', e)
      }

      try {
        // 停止所有 video/audio 元素绑定的媒体流，并清空 srcObject
        cameraManager.stopAllMediaElements()
        // 停止 CameraManager 已记录的所有流
        cameraManager.stopAllStreams()
      } catch (e) {
        console.warn('强制关闭本地设备时出现问题:', e)
      }
    },
    done() {
      // 获取所需数据
      const score = this.$store.state.interviewState.interviewScore
      const interviewId = this.$store.state.interviewState.interviewId
      const duration = this.$store.state.interviewState.actualInterviewDuration || this.$store.state.interviewState.interviewDuration

      const dialogues = JSON.stringify(this.$store.state.interviewState.dialogues);


      const interviewData = {
        answer_content_desc: dialogues,
        answer_content_score: this.$store.state.interviewState.content,
        body_language_desc: "站起，保持 fermi  fermi  fermi",
        body_language_score: this.$store.state.interviewState.body_language,
        facial_expression_desc: "站起，保持 fermi  fermi  fermi",
        facial_expression_score: this.$store.state.interviewState.facial_expression,
        grooming_desc: "站起，保持 fermi  fermi  fermi",
        grooming_score: this.$store.state.interviewState.grooming,
        interview_id: interviewId,
        overall_score: Math.round((this.$store.state.interviewState.interviewScore && this.$store.state.interviewState.interviewScore.totalScore) || 0),
        interview_time: `${duration}分钟`,
        interview_tone_desc: "站起，保持 fermi  fermi  fermi",
        interview_tone_score: this.$store.state.interviewState.interview_tone,
        jd_url: this.$store.state.interviewState.jd?.url || "",
        resume_url: this.$store.state.interviewState.cv?.url || "",
        timely_response_desc: "站起，保持 fermi  fermi  fermi",
        timely_response_score: this.$store.state.interviewState.timely_response,
        video_path: "",
        interview_position: this.position || '未命名面试',
      }

      // 打印请求数据以验证
      console.log('准备发送到后端的面试数据:', JSON.stringify(interviewData, null, 2))

      // 不足5分钟则不保存成绩，直接跳转面试解析并打开反馈
      // 注意：不足5分钟的面试已经在 handleShortEndConfirm 中处理了跳转，这里不需要重复处理
      if (this.isShortInterview) {
        return
      }

      // 调用API保存面试记录
      this.$message.info('正在保存面试记录...')

      // 导入API函数
      const { addUserInterview } = require('@/api/mianshilishi.js')

      //调用
      addUserInterview(interviewData).then(response => {
        console.log('添加面试记录API调用成功，完整响应:', response)
        console.log('响应状态码:', response.status)
        console.log('响应数据:', response.data)

        if (response.data && response.data.code === 0) {
          this.$message.success('面试记录保存成功')
        } else {
          this.$message.warning('面试记录保存提示：' + (response.data.msg || '未知状态'))
        }
      }).catch(error => {
        console.error('保存面试记录失败详情：', error)
        this.$message.error('面试记录保存失败，请稍后重试')
      }).finally(() => {
        this.$message.success('最终得分：' + Math.round((this.$store.state.interviewState.interviewScore && this.$store.state.interviewState.interviewScore.totalScore) || 0))
        this.waitForOverInterview = false
        // 触发视频推荐获取
        this.fetchRecommendVideos()
        setTimeout(() => {
          this.$router.push('/store/Interview_Analysis')
        }, 3000)

      })

    },
    async fetchRecommendVideos() {
      try {
        const cv = this.$store.state.interviewState.cv
        const jd = this.$store.state.interviewState.jd
        const resume_url = cv && cv.url ? cv.url : localStorage.getItem('cv_url')
        const jd_url = jd && jd.url ? jd.url : localStorage.getItem('jd_url')
        if (!resume_url || !jd_url) return
        const { data } = await getRecommendVideo({ resume_url, jd_url })
        if (data && data.code === 1 && Array.isArray(data.data)) {
          this.$store.commit('interviewState/SET_RECOMMEND_VIDEOS', data.data)
        }
      } catch (e) {
        console.error('拉取视频推荐失败:', e)
      }
    },
    playPreheater() {
      // this.$refs.videoRef.playPreheater()
    },
    toggleAudioProcessor() {
      this.showAudioProcessor = !this.showAudioProcessor
    },
    playAnim(animName) {
      // 防抖机制：避免频繁切换动画
      if (this.anim.curAnim === animName) {
        return
      }

      // 清除之前的防抖定时器
      if (this.animDebounceTimer) {
        clearTimeout(this.animDebounceTimer)
      }

      // 设置防抖延迟
      this.animDebounceTimer = setTimeout(() => {
        this.anim.curAnim = animName
        this.lastAnimSwitchTime = Date.now()
      }, 100) // 100ms防抖延迟
    },
    forceSetAnimState(animName, source = 'unknown') {
      // 清除防抖定时器
      if (this.animDebounceTimer) {
        clearTimeout(this.animDebounceTimer)
      }

      this.anim.curAnim = animName
      this.lastAnimSwitchTime = Date.now()
    },
    async initializeRtc() {
      if (this.isRtcInitialized) return
      try {
        this.rtcStatusMessage = 'RTC 初始化中...'
        console.log('RTC 初始化中...')

        // load rtc token
        const rtcToken = await getRtcToken()
        this.token = rtcToken.data.data.token
        this.roomId = String(rtcToken.data.data.roomId)

        // load user id from local storage
        const userInfo = localStorage.getItem('userInfo')
        if (userInfo) {
          this.userId = String(JSON.parse(userInfo).id)
        }

        // Hardcoded values
        const appId = this.appId
        const userId = this.userId // User's fixed ID
        const roomId = this.roomId // Fixed room ID

        RtcClient.createEngine({ userId, roomId, appId })

        RtcClient.addEventListeners({
          [VERTC.events.onUserJoined]: (e) => {
            console.log('onUserJoined', e)
            this.rtcStatusMessage = `用户 ${e.userName || e.userId} 已加入`
            // Check if the AI bot joined
            if (e.userId !== userId) {
              console.log('AI Bot joined the room.')
            }
          },

          [VERTC.events.onUserLeave]: (e) => {
            console.log('onUserLeave', e)
            this.rtcStatusMessage = `用户 ${e.userName || e.userId} 已离开`
            if (e.userId !== userId) {
              this.isAiSpeaking = false
              this.playAnim('idle')
              console.log('AI Bot left the room.')
            }
          },
          [VERTC.events.onUserPublishStream]: (e) => {
            console.log('onUserPublishStream', e)
            const aiUserIdPrefix = 'RobotMan_'
            console.log('e.userId', e.userId)
            if (e.isAudio && e.userId.startsWith(aiUserIdPrefix)) {
              // 不在这里直接设置动画状态，等待实际音频数据
              this.rtcStatusMessage = 'AI 音频流已发布'
            }
          },
          [VERTC.events.onUserUnpublishStream]: (e) => {
            console.log('onUserUnpublishStream', e)
            const aiUserIdPrefix = 'RobotMan_'
            if (e.isAudio && e.userId.startsWith(aiUserIdPrefix)) {
             // 音频流停止时立即切换到idle状态
             this.isAiSpeaking = false
              this.isAiCurrentlySpeaking = false
              this.rtcStatusMessage = 'AI 音频流已停止'
              this.playAnim('idle')
            }
          },

          // 远端 AI 说话判断

          /*           [VERTC.events.onRemoteStreamStats]: (e) => {
          
                      if (e.audioStats.receivedKBitrate < 35) {
          
          
                        this.playAnim('idle')
                        console.log('AI 停止说话')
          
                      } else {
                        this.playAnim('talk')
                        console.log('AI 正在说话')
          
                      }
                    }, */

          // 会话历史
          /*           [VERTC.events.onRoomBinaryMessageReceived]: (e) => {
                      const msg = tlv2String(e.message)
                      const data = JSON.parse(msg.value).data[0]
                      if (!this.msgHis[this.msgHisIndex] && data.definite) {
                        return
                      }
                      if (!data.definite) {
                        this.msgHis[this.msgHisIndex] = {
                          userId: data.userId,
                          text: decodeURIComponent(data.text),
                        }
                      } else {
                        this.msgHisIndex += 1
                      }
                      // AI Say Verify
                      if (data.userId.startsWith(this.botName)) {
                        if (!data.definite) {
                          
                          this.playAnim('talk')
                          console.log('AI 正在说话')
                        } else {
                         
                            this.playAnim('idle')
                            console.log('AI 停止说话')
                     
                        }
                      }
                    }, */
                              // 远端 AI 说话判断 - 基于音频流统计数据的精确检测
          [VERTC.events.onRemoteStreamStats]: (e) => {
            // 检查是否是AI用户的音频流
            const aiUserIdPrefix = 'RobotMan_'
            if (e.userId && e.userId.startsWith(aiUserIdPrefix) && e.audioStats) {
              const audioBitrate = e.audioStats.receivedKBitrate || 0
              const audioLevel = e.audioStats.audioLevel || 0
              
              // 使用更精确的阈值判断AI是否在说话
              const isSpeaking = audioBitrate > 20 && audioLevel > 0.01
              
              // 检查最近是否有消息处理控制的动画切换
              const timeSinceLastSwitch = Date.now() - this.lastAnimSwitchTime
              const isRecentMessageControl = timeSinceLastSwitch < 2000 // 2秒内的消息控制
              
              // 只有当状态真正改变时才更新动画，并且优先级低于消息处理
              if (isSpeaking && !this.isAiSpeaking && !this.isAiCurrentlySpeaking && !isRecentMessageControl) {
                this.isAiSpeaking = true
                this.playAnim('talk')
              } else if (!isSpeaking && this.isAiSpeaking && !this.isAiCurrentlySpeaking && !isRecentMessageControl) {
                // 只有在消息处理没有控制状态且不是最近的消息控制时才允许音频流检测切换
                this.isAiSpeaking = false
                this.playAnim('idle')
              }
            }
          },

          [VERTC.events.onRoomBinaryMessageReceived]: (e) => {
            try {

              const msg = tlv2String(e.message);
              // console.log("TLV Parsed Result:", msg);

              const jsonData = JSON.parse(msg.value);
              // console.log("Parsed JSON Data:", jsonData);

              const data = jsonData.data[0];

              if (!data || !data.text) {
                console.warn("Invalid or incomplete data received.");
                return;
              }

              // 无论 definite 是否为 true，都更新当前索引的内容
              this.msgHis[this.msgHisIndex] = {
                userId: data.userId,
                text: decodeURIComponent(data.text), // 确保覆盖或追加逻辑正确
              };

              // 如果是最终段落，移动到下一个索引
              if (data.definite) {
                this.msgHisIndex += 1;
              }
              /*       // 解析 TLV 格式的消息
                    const msg = tlv2String(e.message);
                    console.log("TLV Parsed Result:", msg);
      
                    // 解析 JSON 数据
                    const jsonData = JSON.parse(msg.value);
                    console.log("Parsed JSON Data:", jsonData);
      
                    const data = jsonData.data[0];
      
                    // 检查数据完整性
                    if (!data || !data.text) {
                      console.warn("Invalid or incomplete data received.");
                      return;
                    }
      
                    // 更新会话历史记录
                    if (!this.msgHis[this.msgHisIndex] && data.definite) {
                      return;
                    }
                    if (!data.definite) {
                      this.msgHis[this.msgHisIndex] = {
                        userId: data.userId,
                        text: decodeURIComponent(data.text),
                      };
                    } else {
                      this.msgHisIndex += 1;
                    }
       */
              // AI 动画逻辑
              if (data.userId.startsWith(this.botName)) {
                if (!data.definite) {
                  // AI开始说话 - 只有在真正有内容且之前不在说话时才切换
                  if (!this.isAiCurrentlySpeaking) {
                    this.isAiCurrentlySpeaking = true;
                    this.isAiSpeaking = true;
                    this.forceSetAnimState('talk', '消息处理-开始');
                  }
                } else {
                  if (this.isAiCurrentlySpeaking) {
                    // 延迟200ms后切换到idle状态，确保与语音同步
                    setTimeout(() => {
                      if (this.isAiCurrentlySpeaking) {
                        this.isAiCurrentlySpeaking = false;
                        this.isAiSpeaking = false;
                        this.forceSetAnimState('idle', '消息处理-结束');
                      }
                    }, 200);
                  }
                  console.log('AI 停止说话');
                }
              }
            } catch (error) {
              console.error("Error processing room message:", error);
            }
          },
          [VERTC.events.onUserStartAudioCapture]: (e) => {
            console.log('onUserStartAudioCapture', e)
          },
          [VERTC.events.onUserStopAudioCapture]: (e) => {
            console.log('onUserStopAudioCapture', e)
          },
          [VERTC.events.onError]: (e) => {
            console.error('RTC 错误:', e)
            this.rtcStatusMessage = `RTC 错误: ${e.msg || e.errorCode}`
            this.$message.error(`RTC 错误: ${e.msg || e.errorCode}`)
          },
          [VERTC.events.onWarning]: (e) => {
            console.warn('RTC 警告:', e)
            this.$message.warning(`RTC 警告: ${e.msg || e.errorCode}`)
          },
          [VERTC.events.onConnectionStateChanged]: (state, reason) => {
            console.log('Connection state changed:', state, reason)
            this.rtcStatusMessage = `连接状态: ${state}`
          },
          [VERTC.events.onNetworkTypeChanged]: (type) => {
            console.log('Network type changed:', type)
            this.rtcStatusMessage = `网络类型: ${type}`
          },
        })

        this.isRtcInitialized = true
        this.rtcStatusMessage = 'RTC 初始化完成'
        console.log('RTC 初始化完成')
      } catch (error) {
        console.error('RTC 初始化失败:', error)
        this.rtcStatusMessage = `RTC 初始化失败: ${error.message || error}`
        this.$message.error(`RTC 初始化失败: ${error.message || error}`)
      }
    },

    async connectAndStartAi() {
      if (!this.isRtcInitialized || this.isRtcConnected) return

      try {
        this.rtcStatusMessage = '连接房间并启动 AI 中...'
        console.log('连接房间并启动 AI 中...')

        const token = this.token
        const userId = this.userId
        const roomId = this.roomId
        const appId = this.appId

        const devices = await RtcClient.getDevices()
        const audioInputs = devices?.audioInputs || []
        if (audioInputs.length === 0) {
          throw new Error('未找到可用的麦克风设备')
        }
        const defaultMic = audioInputs[0]
        console.log(`使用麦克风: ${defaultMic}`)

        await RtcClient.joinRoom({ token })
        // username: `user_${userId}`
        console.log('已加入房间')

        this.microphone = defaultMic

        await RtcClient.startAudioCapture(defaultMic)
        console.log('已开启本地音频采集')
        this.isRtcConnected = true
        this.rtcStatusMessage = '已连接，正在启动 AI Bot...'

/*         const botConfig = {
          TaskId: userId,
          RoomId: roomId,
          AppId: appId,
          AgentConfig: {
            TargetUserId: [userId],
            UserId: this.botName,
            WelcomeMessage: this.welcomeMsg,
          },
          Config: { 
            thinking: "disabled",
            LLMConfig: {
              Mode: 'ArkV3',
              EndPointId: 'ep-20250617004108-c7wqs',
              MaxTokens: 4096,
              Temperature: 0.6,
              frequency_penalty: 0.2,
              presence_penalty: 0.1,
              TopP: 0.7,
              SystemMessages: [this.prompt],
              ModelName: 'doubao-seed-1-6-flash-250615',

            },
            TTSConfig: {
              Provider: 'volcano',
              ProviderParams: {
                app: { AppId: '7386821752', Cluster: 'volcano_tts' },
                audio: { voice_type: 'ICL_zh_female_huopodiaoman_tob', speed_ratio: 1 },
              },
              IgnoreBracketText: [1, 2, 3, 4, 5],
            },
            ASRConfig: {
              Provider: 'volcano',
              ProviderParams: {
                Mode: 'bigmodel',
                AppId: '7386821752',
                AccessToken: '3_Vx6Blujp4H8Vos3V42B05-tm60g377',
                ApiResourceId: 'volc.bigasr.sauc.duration',
                StreamMode: 0
              },
            },
            InterruptMode: 0,
          },
        } */
        const botConfig = {
          TaskId: userId,
          RoomId: roomId,
          AppId: appId,
          AgentConfig: {
            TargetUserId: [userId],
            UserId: this.botName,
            WelcomeMessage: this.welcomeMsg,
          },
          Config: {
            thinking: "disabled",
            LLMConfig: {
              ThinkingType: 'disabled',
              Mode: 'ArkV3',
              EndPointId: 'ep-20251031105537-szklb',
              MaxTokens: 128,
              Temperature: 0.3,
              frequency_penalty: 0.2,
              presence_penalty: 0.1,
              TopP: 0.3,
              SystemMessages: [this.prompt, FIXED_BORDER],
              ModelName: 'doubao-seed-1-6-251015',
      Prefill: true,
      reasoning_effort:"minimal",
            },
            TTSConfig: {
              Provider: "volcano_bidirection",
      ProviderParams: {
        app: {
          appid: "7386821752",
          token: "3_Vx6Blujp4H8Vos3V42B05-tm60g377",
        },
        audio: {
          voice_type: "ICL_zh_female_rouguhunshi_v1_tob",
          speech_rate: 0,
        },
        ResourceId: "volc.service_type.10029",
      },
              // Provider: 'volcano',
              // ProviderParams: {
              //   app: { AppId: '7386821752', Cluster: 'volcano_tts' },
              //   audio: { voice_type: 'ICL_zh_female_huopodiaoman_tob', speed_ratio: 1 },
              // },
              // IgnoreBracketText: [1, 2, 3, 4, 5],
            },
            ASRConfig: {
              Provider: 'volcano',
              ProviderParams: {
                Mode: 'bigmodel',
                AppId: '7386821752',
                AccessToken: '3_Vx6Blujp4H8Vos3V42B05-tm60g377',
                ApiResourceId: 'volc.bigasr.sauc.duration',
                StreamMode: 0
              },
              VADConfig: {
                AIVAD: true, 
                SilenceTime: 1000, 
              },
            },
            InterruptMode: 1,
          },
};
        await RtcClient.startAudioBot(roomId, userId, botConfig)
        console.log('AI Bot 已启动')
        this.rtcStatusMessage = 'AI 面试官已准备就绪'
      } catch (error) {
        console.error('连接或启动 AI 失败:', error)
        this.rtcStatusMessage = `连接/启动失败: ${error.message || error}`
        this.$message.error(`连接或启动 AI 失败: ${error.message || error}`)
        await this.disconnectAndStopAi()
      }
    },

    async disconnectAndStopAi() {
      if (!this.isRtcConnected && !RtcClient.audioBotEnabled) {
        console.log('RTC 未连接或 AI Bot 未启动，无需断开。')
        await this.forceCloseAllMediaStreams()
        return
      }

      try {
        this.rtcStatusMessage = '正在停止 AI 并断开连接...'
        console.log('正在停止 AI 并断开连接...')

        const userId = this.userId
        const roomId = this.roomId

        await RtcClient.stopAudioBot(roomId, userId)
        console.log('AI Bot 已停止')
        this.isAiSpeaking = false
        this.playAnim('idle')

        await RtcClient.stopAudioCapture()
        console.log('已停止本地音频采集')

        await RtcClient.leaveRoom()
        console.log('已离开房间')

        this.isRtcConnected = false
        this.rtcStatusMessage = '已断开连接'
        console.log('已断开连接')
      } catch (error) {
        console.error('停止 AI 或断开连接失败:', error)
        this.rtcStatusMessage = `停止/断开失败: ${error.message || error}`
        this.$message.error(`停止 AI 或断开连接失败: ${error.message || error}`)
      } finally {
        // 无论成功或失败，都要释放所有资源
        try {
          // 停止噪音检测
          this.stopNoiseDetection()
          // 停止截图定时器
          this.stopScreenshotTimer()
          // 强制释放所有媒体资源
          await this.forceCloseAllMediaStreams()
        } catch (error) {
          console.error('释放资源时出错:', error)
        }
        // 重置状态
        this.isRtcConnected = false
        this.isAiSpeaking = false
      }
    },

    async interruptAi() {
      if (!this.isRtcConnected || !this.isAiSpeaking) return

      try {
        this.rtcStatusMessage = '正在打断 AI...'
        console.log('正在打断 AI...')

        const userId = this.userId
        const roomId = this.roomId

        await RtcClient.stopAudioVoice(roomId, userId)
        this.rtcStatusMessage = '已请求打断 AI'
        console.log('已请求打断 AI')
      } catch (error) {
        console.error('打断 AI 失败:', error)
        this.rtcStatusMessage = `打断 AI 失败: ${error.message || error}`
        this.$message.error(`打断 AI 失败: ${error.message || error}`)
      }
    },
    async sendLastQuestionToAI() {
      await RtcClient.sendTextToSpeech('同学回答的很全面，本次面试表现很优秀，由于时间关系，我们本次面试到此结束啦，同学可以点击结束面试按钮查看本次面试表现，祝同学找到心仪的工作，加油欧', 2);
      await RtcClient.stopAudioCapture()//停止音频采集
    },

    // 修复convertToTLV方法（确保存在且正确转换）
    convertToTLV(data) {
      const jsonString = JSON.stringify(data);
      const encoder = new TextEncoder();
      return encoder.encode(jsonString).buffer; // 使用.buffer获取ArrayBuffer
    },

    // 倒计时30秒时触发
    handleThirtySecondsLeft() {
      console.log('倒计时30秒时触发提示')
      this.isFinalQuestionAsked = true; // 设置标志，表示最后一个问题已被问出
      this.sendLastQuestionToAI();

    },

    // 开始定时拍照
    startScreenshotTimer() {
      console.log('开始定时拍照功能')
      this.screenshotCount = 0
      this.screenshotUrls = []
      
      // 延迟3秒后拍第一张照片，让视频有时间加载
      setTimeout(() => {
        console.log('延迟3秒后开始第一张拍照')
        this.takeScreenshot()
      }, 3000)
      
      // 设置定时器，每隔一分钟拍一次
      this.screenshotTimer = setInterval(() => {
        if (this.screenshotCount < this.maxScreenshots) {
          this.takeScreenshot()
        } else {
          this.stopScreenshotTimer()
        }
      }, 60000) // 60秒 = 1分钟
    },

    

    // 停止定时拍照
    stopScreenshotTimer() {
      if (this.screenshotTimer) {
        clearInterval(this.screenshotTimer)
        this.screenshotTimer = null
        console.log('定时拍照已停止')
      }
    },

    // 拍照并上传
    async takeScreenshot() {
      try {
        console.log(`开始拍摄第 ${this.screenshotCount + 1} 张照片`)
        
        // 获取视频元素 - 通过查找页面中的所有video元素
        const allVideos = document.querySelectorAll('video')
        console.log('页面中的所有video元素:', allVideos)
        
        if (allVideos.length === 0) {
          console.error('页面中没有找到任何video元素')
          return
        }

        // 使用第一个可用的视频元素
        const videoElement = allVideos[0]
        console.log('使用视频元素:', videoElement)

        // 检查视频是否已加载
        if (videoElement.readyState < 2) {
          console.warn('视频尚未加载完成，readyState:', videoElement.readyState)
          // Safari可能需要更多时间加载，延迟重试
          this.screenshotRetryTimeoutId = setTimeout(() => this.takeScreenshot(), 1000)
          return
        }

        console.log('视频尺寸:', {
          videoWidth: videoElement.videoWidth,
          videoHeight: videoElement.videoHeight,
          clientWidth: videoElement.clientWidth,
          clientHeight: videoElement.clientHeight
        })

        // 创建canvas来捕获视频帧
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d', { willReadFrequently: true })
        
        // 设置canvas尺寸
        canvas.width = videoElement.videoWidth || videoElement.clientWidth
        canvas.height = videoElement.videoHeight || videoElement.clientHeight
        
        console.log('Canvas尺寸:', { width: canvas.width, height: canvas.height })
        
        // 绘制视频帧到canvas
        ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height)
        console.log('视频帧已绘制到canvas')
        
        // 将canvas转换为blob
        const blob = await new Promise(resolve => {
          canvas.toBlob(resolve, 'image/jpeg', 0.8)
        })
        
        console.log('生成的blob:', blob)
        
        if (!blob) {
          console.error('无法生成图片blob')
          return
        }

        // 创建文件对象
        const file = new File([blob], `screenshot_${Date.now()}.jpg`, {
          type: 'image/jpeg'
        })

        // 构造上传参数
        const formData = new FormData()
        formData.append('file', file)

        console.log('开始上传截图...')
        
        // 调用上传接口
        const response = await lxUploadFile(formData)
        console.log('上传响应:', response)

        if (response && response.data && response.data.code === 1 && response.data.data && response.data.data.url) {
          const imageUrl = response.data.data.url
          // 使用面试开始时间计算当前第几秒，若无开始时间则回退为0秒
          const baseStartTime = this.startTimestamp || this.interviewStartTime
          const screenshotTime = baseStartTime ? Math.floor((Date.now() - baseStartTime) / 1000) : 0

          // 存储截图信息
          this.screenshotUrls.push({
            imageUrl,
            screenshotTime
          })

          this.screenshotCount++
          console.log(`第 ${this.screenshotCount} 张截图上传成功:`, imageUrl)
          console.log(`截图面试秒数: ${screenshotTime}s`)

          // 立即保存截图到数据库
          await this.saveSingleScreenshot(imageUrl, screenshotTime)
        } else {
          console.error('截图上传失败:', response)
        }
      } catch (error) {
        console.error('拍照失败:', error)
      }
    },

    // 保存单张截图到数据库
    async saveSingleScreenshot(imageUrl, screenshotTime) {
      try {
        const interviewId = this.$store.state.interviewState.interviewId
        console.log('保存单张截图到数据库:', { interviewId, imageUrl, screenshotTime })
        
        const response = await saveInterviewScreenshot({
          interview_id: interviewId,
          image_url: imageUrl,
          screenshot_time: screenshotTime
        })
        
        if (response && response.data && response.data.code == 1) {
          console.log('截图保存到数据库成功')
        } else {
          console.warn('截图保存到数据库失败:', response)
        }
      } catch (error) {
        console.error('保存截图到数据库失败:', error)
      }
    },

    // 保存面试截图（保留用于批量保存，但主要逻辑已改为单张保存）
    async saveScreenshots() {
      if (this.screenshotUrls.length === 0) {
        console.log('没有截图需要保存')
        return
      }

      try {
        const interviewId = this.$store.state.interviewState.interviewId
        console.log('开始保存面试截图，面试ID:', interviewId)
        console.log('截图数据:', this.screenshotUrls)

        // 批量保存截图
        const savePromises = this.screenshotUrls.map(screenshot => {
          return saveInterviewScreenshot({
            interview_id: interviewId,
            image_url: screenshot.imageUrl,
            screenshot_time: screenshot.screenshotTime
          })
        })

        const results = await Promise.all(savePromises)
        console.log('截图保存结果:', results)
        
        // 检查是否有保存失败的
        const failedSaves = results.filter(result => 
          !result.data || result.data.code !== 0
        )
        
        if (failedSaves.length > 0) {
          console.warn('部分截图保存失败:', failedSaves)
        } else {
          console.log('所有截图保存成功')
        }
      } catch (error) {
        console.error('保存截图失败:', error)
      }
    },
  },
  computed: {
    prompt() {
      if (this.$store.state.interviewState.interviewLanguage == 1) {
        return this.$store.state.interviewState.prompt
      } else if (this.$store.state.interviewState.interviewLanguage == 2) {
        return this.$store.state.interviewState.prompt + '现在要求使用英语进行面试，所有问题都必须使用英语进行提问并且后面的提问中不再使用中文。Now please speak in English.'
      }

    },
    welcomeMsg() {
      if (this.$store.state.interviewState.interviewLanguage == 1) {
        return '你好，我是你的AI面试官 Cathy，请问准备好开始面试了吗？'
      } else if (this.$store.state.interviewState.interviewLanguage == 2) {
        return 'Hello, I am your AI interviewer Cathy. Are you ready to start the interview?'
      }
    }
  },
  beforeDestroy() {
    // 清理噪音检测定时器
    this.stopNoiseDetection()
    
    // 清理截图定时器
    this.stopScreenshotTimer()
    
    // 页面卸载时也做一次彻底清理，避免浏览器保留"正在访问摄像头"的提示
    if (this.$refs && this.$refs.videoRef && this.$refs.videoRef.releaseResources) {
      this.$refs.videoRef.releaseResources().catch(() => { })
    }
    if (typeof this.forceCloseAllMediaStreams === 'function') {
      this.forceCloseAllMediaStreams()
    }
  },

}
</script>
<style scoped lang="css" src="./assets/index.css" />
<style scoped>
@media (max-width: 1600px) {
  .scaler {
    transform-origin: top left;
    transform: scale(0.67);
    /* pointer-events: none;  */
  }
}

@media (min-width: 1600px) {
  .scaler {
    transform-origin: center center;
    transform: scale(0.87);
  }
}

/* .scaler {
  transform-origin: left top;
  transform: scale(0.67);
  允许鼠标事件穿透到Three.js场景
  pointer-events: none; 
} */

.image_1_ {
  width: 127px;
  height: 161px;
  margin: 78px 0 0 221px;
}

.text_2_ {
  width: 569px;
  height: 22px;
  overflow-wrap: break-word;
  color: rgba(101, 101, 135, 1);
  font-size: 22px;
  font-family: Afacad-Regular;
  font-weight: NaN;
  text-align: center;
  white-space: nowrap;
  line-height: 22px;
  margin: 22px 0 85px 0;
}

.not-allowed {
  width: 100%;
  height: 100%;
  background: linear-gradient(to top right, transparent 45%, rgba(177, 110, 249, 0.2) 45%, rgba(177, 110, 249, 1) 55%, transparent 55%);
  margin-top: -48px;
}

.spinner {
  border: 5px solid rgba(126, 180, 235, 1);
  border-radius: 50%;
  border-top: 5px solid rgba(177, 110, 249, 1);
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.audio-stream-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 100;
  background-color: rgba(255, 255, 255, 0.9);
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  max-width: 500px;
  width: 90%;
}

.label_4 {
  width: 48px;
  height: 48px;
  border-radius: 12px;
}

.image-wrapper_4 {
  border-radius: 12px;
  background-color: rgba(177, 110, 249, 0.2);
  height: 48px;
  position: relative;
}

.audio-processor-badge {
  position: absolute;
  top: -5px;
  right: -5px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #f56c6c;
}

/* 自定义弹窗样式 */
.custom-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.popup-content {
  background-color: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border-radius: 20px;
  padding: 40px;
  text-align: center;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  max-width: 400px;
  width: 90%;
}

.popup-image {
  width: 200px;
  height: auto;
  margin-bottom: 20px;
  border-radius: 10px;
}

.popup-text {
  color: #333;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 500;
  font-family: Afacad-Regular;
}

 .btn {
   min-width: 88px;
   height: 36px;
   border-radius: 8px;
   border: none;
   cursor: pointer;
   font-size: 14px;
 }
 
 .btn-primary {
   background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
   color: #fff;
 }
 
 .btn-secondary {
   background: #f5f5f7;
   color: #666;
 }

.btn-outline {
  min-width: 120px;
  height: 40px;
  border-radius: 10px;
  background: rgba(255,255,255,0.9);
  border: 1px solid rgba(177,110,249,0.6);
  color: #656587;
}

.btn-gradient {
  min-width: 120px;
  height: 40px;
  border-radius: 10px;
  background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
  color: #fff;
}

.ui-title {
  font-size: 20px;
  font-weight: 700;
  margin-top: 6px;
  margin-bottom: 6px;
  background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.ui-desc {
  color: #656587;
  font-size: 14px;
  line-height: 1.7;
  text-align: center;
  max-width: 90%;
  margin: 6px auto 10px;
}

.ui-strong {
  font-weight: 700;
}

.ui-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-top: 8px;
}

/* 噪音检测弹窗样式 */
.noise-detection-popup {
  max-width: 480px;
  width: 85%;
  padding: 0;
  background-color: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
}

.noise-detection-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 24px 0 24px;
  margin-bottom: 12px;
}

.noise-title-spacer {
  width: 82px; /* 与图片宽度相同 */
  margin-right: 12px; /* 与图片和文字的间距相同 */
}

.noise-title {
  font-size: 18px;
  font-weight: 700;
  color: #656587;
  margin: 0;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  text-align: left;
}

.close-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #B16EF9;
  border: none;
  color: white;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.close-btn:hover {
  background: #9B5DE5;
}

.noise-content {
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 0 24px 18px 24px;
}

.noise-image {
  flex-shrink: 0;
}

.check-image {
  width: 82px;
  height: auto;
  border-radius: 6px;
}

.noise-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 9px;
}

.noise-message {
  color: #65658780  ;
  font-size: 13px;
  line-height: 1.4;
  margin: 0;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  text-align: left;
}

.noise-level-indicator {
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.progress-bar-container {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.progress-bar {
  position: relative;
  height: 12px;
  background: #f0f0f0;
  border-radius: 6px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 62.5%, #FF8C42 75%, #ff6b6b 100%);
  border-radius: 6px;
  transition: width 0.3s ease;
}

.progress-marker {
  position: absolute;
  top: 0;
  width: 2px;
  height: 100%;
  background: #333;
  transform: translateX(-50%);
}

.progress-current {
  position: absolute;
  top: -2px;
  width: 16px;
  height: 16px;
  background: #FF8C42;
  border: 2px solid white;
  border-radius: 50%;
  transform: translateX(-50%);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  transition: left 0.3s ease-out;
}

.progress-labels {
  position: relative;
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
  margin-top: 5px;
}

.label-0 {
  color: #7EB4EB;
  font-weight: 500;
}

.label-50 {
  color: #B16EF9;
  font-weight: 500;
}

.label-80 {
  color: #ff6b6b;
  font-weight: 500;
}

.noise-labels {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  margin-top: 5px;
}

.current-noise {
  color: #B16EF9;
  font-weight: 500;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.current-noise.noise-high {
  color: #ff6b6b;
  font-weight: 700;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.recommended-noise {
  color:  #656587;
  font-weight: 500;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.noise-actions {
  display: flex;
  gap: 9px;
  justify-content: center;
  margin-top: 11px;
}

.btn-outline {
  min-width: 90px;
  height: 36px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: #656587;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.btn-outline:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
  transform: translateY(-1px);
}

.btn-gradient {
  min-width: 90px;
  height: 36px;
  border-radius: 6px;
  background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
  border: none;
  color: white;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  box-shadow: 0 2px 8px rgba(177, 110, 249, 0.2);
}

.btn-gradient:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 16px rgba(177, 110, 249, 0.4);
}

.btn:disabled {
  cursor: not-allowed;
  background: #BEBEBE  !important;
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
}

.btn:disabled:hover {
  transform: none;
  box-shadow: none;
}

@media (max-width: 768px) {
  .noise-content {
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 0 12px 12px 12px;
  }
  
  .check-image {
    width: 68px;
  }
  
  .noise-detection-header {
    padding: 9px 12px 0 12px;
  }
  
  .noise-detection-popup {
    width: 90%;
    max-width: 400px;
  }
}
</style>
